<script>
    import { colorScale } from '../utils/color.js';
</script>

<div class="legend">
    <div class="legend-votes">
        <div class="legend-label x">
            <div class="legend-label-left">← Bass</div>
            <div class="legend-label-right">Caruso →</div>
        </div>
        <div class="legend-item"></div>
    </div>
    <!-- <div class="legend-no-votes">
        <div class="legend-label">No votes</div>
        <div class="legend-item no-votes"></div>
    </div> -->
</div>